import React, { useEffect, useState } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { TextInput, CheckboxInput } from '../../../Helpers/Inputs';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { object, mixed, string } from 'yup';
import Button from '@material-ui/core/Button';
import { format } from 'date-fns';
import CovrButton from '../../../Helpers/Buttons/CovrButton';
import { InputMaskPhone } from '../../../Helpers/Formatters'
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_HEALTH_CLASS_KEY, SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, SESSION_STORAGE_TERM_LENGTH_KEY } from '../../../../sessionStorage'
import '../Haven.scss';

export default function HavenApplyDialog(props) {
  const { register, errors, handleSubmit } = useForm({
    validationSchema: HavenApplyDialog.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const handleChange = (event) => {
    setAccept(event.target.checked);
  };

  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [phone, setPhone] = useState(props.quoteFields.phone);
  const [email, setEmail] = useState(props.quoteFields.email);
  const [firstName, setFirstname] = useState('');
  const [lastName, setLastname] = useState('');

  const HAVEN_TYPE_ID = props.simpleIssue ? 60 : 58;

  const onSubmit = () => {
    setLoading(true);
    props.logQuote(email, phone, props.selectedQuote, HAVEN_TYPE_ID).then(() => {
      submitHavenPost();
    })
  }

  useEffect(() => {
    if (props.hideForm) {
      submitHavenPost();
    }
  }, [])

  const havenPostUrl = HavenHandoffUrl(props.simpleIssue);

  const submitHavenPost = () => {
    const formattedDate = format(new Date(props.quoteFields.birthdate), 'MM-dd-yyyy');

    fetch(`api/HavenLife/AppPreFill?face=${props.quoteFields.coverageAmount}&term=${props.quoteFields.termLength}&stateCode=${props.quoteFields.stateOfResidence}&birthdate=${formattedDate}&healthClass=${props.quoteFields.healthClass}&gender=${props.quoteFields.gender}&tobacco=${props.quoteFields.tobacco === 'yes'}&premium=${props.selectedQuote.monthlyRate}&phone=${phone}&email=${email}&sessionId=${props.sessionId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        return response.text();
      })
      .then((jwt) => {
        setToken(jwt);
        sessionStorage.removeItem(SESSION_STORAGE_ACCOUNT_KEY);
        document.getElementById('havenPostForm').submit();
      });
  }

  const setLocalStorage = () => {
    sessionStorage.setItem(SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, props.quoteFields.coverageAmount);
    sessionStorage.setItem(SESSION_STORAGE_HEALTH_CLASS_KEY, props.quoteFields.healthClass);
    sessionStorage.setItem(SESSION_STORAGE_TERM_LENGTH_KEY, props.quoteFields.termLength);
  };

  return (
    <div>
      {props.hideForm ? null :
        <Form onSubmit={handleSubmit(onSubmit)}>
          <p className="disclaimer-agreement-text">Transferring to Haven</p>
          <Row className="justify-content-center">
            <Col>
              <Row>
                <Col>
                  <div className="form-area">
                    <Form.Group>
                      <TextInput
                        name="firstName"
                        id="firstName"
                        value={firstName}
                        onChange={(e) => setFirstname(e.target.value)}
                        label="First Name"
                        inputRef={register}
                        errors={errors.firstName}
                      />
                    </Form.Group>
                    <Form.Group>
                      <TextInput
                        name="lastName"
                        id="lastName"
                        value={lastName}
                        onChange={(e) => setLastname(e.target.value)}
                        label="Last Name"
                        inputRef={register}
                        errors={errors.lastName}
                      />
                    </Form.Group>
                    <Form.Group>
                      <TextInput
                        name="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        label="Email (Required)"
                        inputRef={register}
                        errors={errors.email}
                      />
                    </Form.Group>
                    <Form.Group>
                      <TextInput
                        name="phone"
                        id="phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        label="Phone (Required)"
                        inputRef={register}
                        errors={errors && errors.phone}
                        InputProps={{
                          inputComponent: InputMaskPhone,
                        }}
                      />
                    </Form.Group>
                  </div>
                </Col>

                <div className="apply-disclaimer-content">
                  <p>
                    Disclaimer Agreement: You understand that by clicking on the “I accept” button below, you are consenting to Covr Financial Technologies Inc (“Covr”) disclosing Policy
                    Summary Information (as defined below) to the financial institution that referred you to Covr with whom you have an existing relationship. “Policy
                    Summary Information” means the following information received by Covr from Mass Mutual, Haven Life Insurance Agency, LLC (“Haven Life”) in
                    connection with your inquiry for insurance coverage: (i) your name; (ii) your address; (iii) the fact that you have applied through Haven Life for
                    an insurance product; (iv) the type of policy that you have applied for and the applicable policy limits; and (v) the status of your application for
                    insurance (e.g. pending or issued). The Policy Summary Information shared with the financial Institution will not include your social security
                    number, any financial account numbers, or any “Protected Health Information” (PHI) as defined under HIPAA.
                  </p>
                  <p>By clicking Continue, you are providing your signed permission for Covr Financial Technologies to contact you at the email and telephone number provided, including via text message and live, automated and pre-recorded telephone calls, even if your number is on a Do Not Call list. You also acknowledge that you have received and agree to our Privacy Policy, Terms of Use, and Consent to Do Business Electronically. You may revoke these consents at any time by emailing us at <a href="mailtovrtech.com">support@covrtech.com</a>.</p>
                </div>
              </Row>

              <Row className="justify-content-center mt-2">
                <Form.Group>
                  <CheckboxInput
                    name="accept"
                    id="accept"
                    checked={accept}
                    errors={errors.accept}
                    inputRef={register}
                    onChange={handleChange}
                    label="I accept"
                    color="primary"
                  />
                </Form.Group>
              </Row>
              <Row className="justify-content-center">
                <Form.Group>
                  <Button
                    variant="contained"
                    color="primary"
                    className={loading ? "covr-button loading mr-2" : "covr-button mr-2"}
                    onClick={setLocalStorage}
                    href="/quote/term-life-insurance/multi-carrier-term"
                    disabled={loading}
                  >
                    <span className="name">BACK</span>
                  </Button>

                  <CovrButton
                    name="CONTINUE"
                    loading={loading}
                  />
                  {/* <Button type="submit" variant="outlined" fullWidth disabled={loading}>Submit</Button> */}
                </Form.Group>
              </Row>

            </Col>
          </Row>
        </Form>
      }

      <form id="havenPostForm" action={havenPostUrl} method="post">
        <input type="hidden" name="token" value={token} />
        <input type="hidden" name="source" value="Covr" />
        <input type="hidden" name="version" value="2.0" />
        {/* <Button type="submit" disabled={props.disabled} onClick={submit} loading={loading} name="CONTINUE TO PARTNER SITE" /> */}
      </form>

    </div>
  );
}

export function HavenHandoffUrl(isHavenSI = false) {
  var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  return isHavenSI ? `https://simple.havenlife.com/amorphic/init/haven-simple.js?utm_source=Covr&utm_campaign=${accountObj.account.accountName}`
    : `https://havenlife.com/amorphic/init/haven.js?utm_source=Covr&utm_campaign=${accountObj.account.accountName}`;
}

HavenApplyDialog.propTypes = {
  logQuote: PropTypes.func.isRequired,
  selectedQuote: PropTypes.object.isRequired,
  simpleIssue: PropTypes.bool,
  campaign: PropTypes.string,
};

HavenApplyDialog.ValidationSchema = object().shape({
  email: string().required('Email is required.').email('Email address must be valid.'),
  phone: string().required('Phone is required.').matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
  firstName: string()
    .matches(/^\s*$|^[ a-zA-ZÀ-ÖØ-öø-ÿ'.-]+$/, 'Numbers not allowed.')
    .required('First Name is required.'),
  lastName: string()
    .matches(/^\s*$|^[ a-zA-ZÀ-ÖØ-öø-ÿ'.-]+$/, 'Numbers not allowed.')
    .required('Last Name is required.'),
  accept: mixed().oneOf([true], 'You must accept the agreement.'),
});



// WEBPACK FOOTER //
// ./src/components/Quoters/Digital/Haven/HavenApplyDialog.js